import * as SentrySdk from "@sentry/browser";
import { GameInfo, Stage } from "./GameInfo";
import { BrowserTracing, Replay, SeverityLevel } from "@sentry/browser";

export class Sentry {
    private readonly gameInfo: GameInfo;
    private initialized: boolean = false;

    public constructor(gameInfo: GameInfo) {
        this.gameInfo = gameInfo;
        this.initialize();
    }

    private initialize(): void {
        if (this.gameInfo.stage === Stage.LOCALHOST) {
            return;
        }
        SentrySdk.init({
            dsn: "https://752588f33a2c4d36b6b92a76c216acd2@o4504909821706240.ingest.sentry.io/4505385195667456",
            environment: this.gameInfo.stage,
            release: `cityversetycoon-pixi@${this.gameInfo.gameVersion}`,
            integrations: [new BrowserTracing(), new Replay()],
            sampleRate: 0.5,
            tracesSampleRate: 0.1,
        });
        this.initialized = true;
    }

    public sendDebug(message: string): void {
        this.captureMessage(message, 'debug');
    }

    public sendInfo(message: string): void {
        this.captureMessage(message, 'info');
    }

    public sendWarning(message: string): void {
        this.captureMessage(message, 'warning');
    }

    public sendEvent(message: string, attachments?: Record<string, string>): void {
        if (!this.initialized) {
            return;
        }
        if (attachments == null) {
            this.captureMessage(message, 'info');
        }
        else {
            SentrySdk.captureMessage(message, {
                level: 'info',
                extra: attachments
            });
        }
    }

    private captureMessage(message: string, level: SeverityLevel): void {
        if (!this.initialized) {
            return;
        }
        SentrySdk.captureMessage(message, level);
    }

    public sendError(exception: Error): void {
        if (!this.initialized) {
            return;
        }
        SentrySdk.captureException(exception);
    }

    public addTag(key: string, value: string): void {
        SentrySdk.setTag(key, value);
    }
}